import React, { useState, useEffect } from 'react'

import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

import { Redo, Undo } from '@material-ui/icons';
import { Avatar, CircularProgress, Dialog, useMediaQuery, Button, DialogActions, DialogTitle, DialogContent } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

function resizeImage2(image, maxWidth, maxHeight, quality) {
    var canvas = document.createElement('canvas');

    var width = image.width;
    var height = image.height;

    if (width > height) {
        if (width > maxWidth) {
            height = Math.round(height * maxWidth / width);
            width = maxWidth;
        }
    } else {
        if (height > maxHeight) {
            width = Math.round(width * maxHeight / height);
            height = maxHeight;
        }
    }

    canvas.width = width;
    canvas.height = height;

    var ctx = canvas.getContext("2d");
    ctx.drawImage(image, 0, 0, width, height);

    return canvas.toDataURL("image/png", quality);
}

export default function CortarImagem(props) {
    const { input: { value, onChange }, aspectType, customWidth = 200, customHeight = 200, textoBotao, cortar, criaLista } = props
    const [dialogOpen, setdialogOpen] = useState(false)
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [isUploading, setIsUploading] = useState(false)
    const [src, setSrc] = useState(null)
    const [imageCrop, setImageCrop] = useState(null)
    const [cropedImg, setCropedImg] = useState(null)


    const [crop, setCrop] = useState({ aspect: 1 })
    const [sizeView, setSizeView] = useState({ width: aspectType === '16/9' ? 355 : 200, height: 200 })
    useEffect(() => {
        if (aspectType === "16/9") {
            setCrop({ aspect: 16 / 9 })
            setSizeView({ width: 355, height: 200 })
        } else if (aspectType === "square") {
            setCrop({ aspect: 1 })
            setSizeView({ width: 200, height: 200 })
        } else if (aspectType === "circle") {
            setCrop({ aspect: 1 })
            setSizeView({ width: 200, height: 200 })
        } else {
            setCrop({ aspect: 16 / 9 })
            setSizeView({ width: +customWidth, height: +customHeight })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [aspectType, customWidth, customHeight])

    let imageLogo = null;

    if (value) {
        imageLogo = `data:image/png;base64,${value}`;
    } else {
        imageLogo = 'data:image/png;base64,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'
    }

    let exibeAlterar = false;

    if (!value || value === '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') {
        exibeAlterar = true;
    }

    const handleFileChange = (event) => {
        const { target } = event;
        const { files } = target
        setIsUploading(true)
        let file = files[0]
        var reader = new FileReader();

        reader.onloadend = function () {
            var image = new Image();
            image.src = reader.result;
            image.onload = function () {
                var resizedDataUrl = resizeImage2(image, 680, 680, 1.0);

                setSrc(resizedDataUrl);
                setIsUploading(false)

                if (!cortar) {
                    concluir(resizedDataUrl);
                } else {
                    setdialogOpen(true)
                }
            }
        };
        reader.readAsDataURL(file)
    }

    const rotate = (direita) => {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext("2d");
        var image = new Image();

        image.src = src;
        image.onload = function () {
            canvas.width = image.height;
            canvas.height = image.width;
            if (direita) {
                ctx.rotate(90 * Math.PI / 180);
                ctx.translate(0, -canvas.width);
            } else {
                ctx.rotate(-90 * Math.PI / 180);
                ctx.translate(-canvas.height, 0);
            }
            ctx.drawImage(image, 0, 0);
            let base64Rotate = canvas.toDataURL();
            setSrc(base64Rotate)
        };
    }

    //Crop

    const onCropComplete = (crop, pixelCrop) => {
        if (imageCrop) {
            const canvas = document.createElement("canvas");

            const scaleX = imageCrop.naturalWidth / imageCrop.width;
            const scaleY = imageCrop.naturalHeight / imageCrop.height;

            canvas.width = crop.width;
            canvas.height = crop.height;
            const ctx = canvas.getContext("2d");

            ctx.drawImage(
                imageCrop,
                crop.x * scaleX,
                crop.y * scaleY,
                crop.width * scaleX,
                crop.height * scaleY,
                0,
                0,
                crop.width,
                crop.height
            );

            // Base64
            const base64Image = canvas.toDataURL('image/png', 1.0);
            setCropedImg(base64Image);

        }
    }
    const concluir = (resizedDataUrl) => {
        let img = cropedImg ? cropedImg : src;
        if (!img && resizedDataUrl) {
            img = resizedDataUrl;
        }
        let foto = img.split(";base64,")[1];
        if (criaLista) {
            onChange(v => (v || []).concat([{ img: foto }]))
        } else {
            onChange(foto)
        }

        let widthAspect = aspectType === '16/9' ? 355
            : aspectType === 'custom' ? +customWidth
                : 200

        let heightAspect = aspectType === 'custom' ? +customHeight : 200

        setIsUploading(false)
        setSrc(null)
        setImageCrop(null)
        setCropedImg(null)
        setCrop({ aspect: 1 })
        // setSizeView({ width: aspectType === '16/9' ? 355 : 200, height: 200 })
        setSizeView({ width: widthAspect, height: heightAspect })
        setdialogOpen(false)
    }

    let tipoBotao = criaLista ? true : false;

    return (
        <>
            {tipoBotao ?
                <>
                    <input
                        accept="image/*"
                        style={{ display: "none" }}
                        id="contained-button-file"
                        multiple
                        type="file"
                        onChange={handleFileChange}
                        disabled={props.disabled}
                    />
                    <label htmlFor="contained-button-file">
                        <Button variant="contained" color="primary" component="span">
                            Upload
                        </Button>
                    </label>
                </>
                :
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minWidth: 240, minHeight: 240 }}>
                    {!isUploading ? <>
                        <label style={{ textAlign: 'center' }}>
                            <Avatar
                                variant={aspectType === 'circle' ? 'circular' : 'square'}
                                alt={textoBotao}
                                style={{
                                    margin: 10,
                                    ...sizeView
                                }}
                                src={imageLogo}
                            />
                            <input
                                style={{ overflow: 'hidden', opacity: 0, display: 'contents' }}
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                                disabled={props.disabled} />
                        </label>
                        {exibeAlterar && <figcaption style={{
                            position: 'relative',
                            top: '-40%',
                            fontSize: 20,
                            color: 'black',
                            textShadow: '0 0 5 black'
                        }}>{textoBotao}</figcaption>}
                    </>
                        : <CircularProgress />}
                </div>
            }

            <Dialog
                fullScreen={fullScreen}
                maxWidth={"lg"}
                open={dialogOpen}
                onClose={() => setdialogOpen(false)}
                scroll={'body'}
            >
                <DialogTitle>{"Cortar a imagem"}</DialogTitle>
                <DialogContent>
                    <div style={{}}>
                        <ReactCrop
                            src={src}
                            crop={crop}
                            onImageLoaded={setImageCrop}
                            onComplete={onCropComplete}
                            onChange={setCrop}
                            circularCrop={aspectType === "circle" ? true : false}
                        />
                        <div style={{ display: 'flex', justifyContent: 'center', flex: 0 }}>
                            <Button onClick={() => {
                                rotate(false);
                            }}> <Undo /></Button>
                            <Button onClick={() => {
                                rotate(true);

                            }}> <Redo /></Button>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' autoFocus onClick={concluir} color="primary">
                        Concluir
                    </Button>
                    <Button onClick={() => {

                        setIsUploading(false)
                        setSrc(null)
                        setImageCrop(null)
                        setCropedImg(null)

                        setCrop({ aspect: 1 })
                        setSizeView({ width: aspectType === '16/9' ? 355 : 200, height: 200 })
                        setdialogOpen(false)
                    }} color="primary" autoFocus>
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
